<!-- MESSAGE SHOW CONFORMATION-->

<section class="approve_message" *ngIf="showMessage">
    <div>
        <ul class="message_title">
            <li><img src="../../../../assets/image/error_message.svg" alt="" class="error_img"></li>
            <li>
                <h6 class="message_text">Are you sure you want to Approve?</h6>
            </li>
        </ul>
        <div>
            <h6 class="main_text">Once asset transfer approved, this action cannot be changed.</h6>
        </div>
    </div>
    <div class="confermation">
        <button class="cancel" (click)="cancel()">CANCEL</button>
        <button class="submit" (click)="submit()">SUBMIT</button>
    </div>
</section>

<!--SUCCESS MESSAGE SHOW  -->

<section class="approve_message" *ngIf="showSuccess">
    <div>
        <ul class="message_title">
            <li><img src="../../../../assets/image/success_message.svg" alt="" class="error_img"></li>
            <li>
                <h6 class="message_text">Success</h6>
            </li>
        </ul>
        <div>
            <h6 class="main_text">The asset transfer has been approved.</h6>
        </div>
    </div>
    <div class="confermation">
        <button class="submit" (click)="ok()">OK</button>
    </div>
</section>